import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as userActions from "../../actions/userActions";
import * as constants from "../../constants";

const getUserLogic = createLogic({
	type: ActionTypes.GET_USER,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 120000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get("/users/me")
					.then(data => {
						dispatch(userActions.getUserSuccess(data.data));
						done();
					})
					.catch(error => {
						dispatch(userActions.getUserFail(error));
						done();
					});
			});
	},
});

export default [getUserLogic];
